var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190.59 137.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".o{fill:url(#l);}.p{fill:url(#b);}.q{fill:url(#n);}.q,.r,.s,.t,.u,.v,.w,.x,.y{fill-rule:evenodd;}.a`{fill:#ffe048;mix-blend-mode:screen;}.a`,.aa,.ab{opacity:.48;}.ac{fill:#f7dfd8;}.ad{fill:#ff896a;}.ae{fill:#7d8591;}.af{fill:#425869;}.ag{fill:#9b5c5c;}.ah{fill:#6397a5;}.ai{fill:#4c2e2e;}.aj{fill:#827c84;}.aj,.ak,.aa,.ab,.al,.am,.an,.ao,.ap,.aq,.ar,.as,.y{mix-blend-mode:multiply;}.aj,.ap,.aq,.ar,.as{opacity:.2;}.ak{fill:#ad5d6e;}.ak,.y{opacity:.4;}.aa{fill:url(#j);}.ab{fill:url(#i);}.al{fill:url(#k);}.al,.am{opacity:.33;}.am{fill:url(#h);}.an{fill:url(#m);}.an,.ao{opacity:.47;}.ao{fill:url(#c);}.ap{fill:url(#g);}.aq{fill:url(#f);}.ar{fill:url(#e);}.as{fill:url(#d);}.r{fill:#dd6876;}.s{fill:#cb5962;}.t{fill:#af4350;}.u{fill:#80c493;}.v{fill:#6b4369;}.w{fill:#936f93;}.x{fill:#ffbdc5;}.y,.at{fill:#90404a;}.au{isolation:isolate;}.at{opacity:.5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -10940.94,
    y1: 101.54,
    x2: -10812.68,
    y2: 101.54,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ff9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#f5775e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -10933.09,
    y1: 60.38,
    x2: -10915.63,
    y2: 85.93,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7aab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a74057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 73.44,
    y1: 19.54,
    x2: 93.67,
    y2: 19.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#727300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a28300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -10875.21,
    y1: 62.92,
    x2: -10842.65,
    y2: 62.92,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -10895.97,
    y1: 64.41,
    x2: -10879.69,
    y2: 64.41,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -10895.93,
    y1: 23.64,
    x2: -10841.79,
    y2: 23.64,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -10843.92,
    y1: 53.59,
    x2: -10824.5,
    y2: 53.59,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -10888.96,
    y1: 89.7,
    x2: -10886.42,
    y2: 89.7,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -10950.66,
    y1: 89.1,
    x2: -10944.76,
    y2: 89.1,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -10881.23,
    y1: 89.89,
    x2: -10837.62,
    y2: 89.89,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -10833.04,
    y1: 99.23,
    x2: -10823.08,
    y2: 99.23,
    gradientTransform: "translate(-10762.57) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ba453f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b82523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -10875.72,
    y1: 62.1,
    x2: -10863.59,
    y2: 80.11,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 225.24,
    y1: 97.68,
    x2: 253.3,
    y2: 97.68,
    gradientTransform: "translate(-217.11)",
    xlinkHref: "#d"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.26,124.03l-57.28-3.52-108.36,9.36,60.48,6.58s39.04,.19,55.24-2.67c18.18-3.21,49.91-9.75,49.91-9.75Z",
    style: {
      fill: "#7d8591"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.31 100.14 69.01 102.94 174.79 102.94 174.16 100.64 173.09 100.63 171.38 100.62 171.37 100.62 129.84 100.43 125.58 100.41 121.26 100.39 112.46 100.35 112.44 100.35 110.75 100.34 110.75 100.34 69.23 100.14 68.31 100.14",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "122.35 63.87 122.38 64.35 122.41 64.77 122.41 64.85 122.46 65.65 122.82 71.34 123.29 78.77 124.54 98.55 124.7 101.08 124.86 103.52 125.94 120.65 125.94 120.65 126.02 121.96 130.62 121.96 130.54 120.94 129.18 103.52 128.99 101.08 128.8 98.57 127.34 79.75 126.71 71.71 126.24 65.65 126.11 63.97 126.1 63.81 126.1 63.75 126.02 62.78 122.35 63.87",
    style: {
      fill: "#4c2e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.03,56.29c-.08,.33-42.74,9.22-42.74,9.22h-7.23s42.29-11.18,48.01-10.69c5.72,.49,1.96,1.47,1.96,1.47Z",
    style: {
      fill: "#4c2e2e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.39 63.72 123.42 64.21 123.45 64.62 123.45 64.7 123.5 65.51 123.86 71.2 124.33 78.62 125.58 98.41 125.74 100.94 125.9 103.38 126.98 120.51 126.98 120.51 127.06 121.82 131.66 121.82 131.58 120.79 130.23 103.38 130.04 100.94 129.84 98.43 128.38 79.61 127.76 71.56 127.29 65.51 127.16 63.82 127.14 63.67 127.14 63.61 127.06 62.64 123.39 63.72",
    style: {
      fill: "#9b5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.42,64.21l.44,6.99c1.42-.09,2.73,.07,3.89,.37l-.62-7.96-3.72,.6Z",
    style: {
      fill: "#4c2e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.53,63.38v2.26s.18-.04,.53-.13c.02,0,.04,0,.06-.02,.02,0,.03,0,.05-.01,.66-.15,1.79-.42,3.28-.78,1.07-.25,2.32-.55,3.7-.88,12.75-3.01,37.05-8.66,37.51-8.14,.02,.02,.05,.1,.08,.24,.01,.05,.03,.1,.04,.16,0,.02,0,.04,.01,.07,.02,.07,.03,.14,.05,.23,.02,.11,.05,.23,.07,.36l.02,.11s.01,.06,.02,.09c0,.04,.02,.09,.03,.13,.02,.12,.05,.24,.07,.36v.05s.02,.05,.02,.08c.02,.11,.04,.22,.06,.33,.02,.09,.03,.18,.05,.28,.02,.13,.05,.27,.07,.42,.02,.09,.03,.18,.05,.28,.02,.13,.05,.26,.07,.4,.02,.12,.04,.24,.06,.36,0,.06,.02,.12,.03,.18,.02,.11,.04,.21,.06,.32,.04,.24,.08,.5,.13,.76,.02,.11,.04,.21,.05,.32,.01,.07,.02,.14,.04,.21,.02,.14,.05,.29,.07,.43,.08,.51,.17,1.05,.26,1.61,.01,.09,.03,.19,.05,.29,.27,1.66,.57,3.51,.88,5.52,.08,.54,.17,1.09,.26,1.65,.12,.79,.25,1.6,.38,2.42,.05,.33,.1,.66,.15,1,.17,1.13,.35,2.29,.53,3.47,.07,.43,.13,.87,.2,1.31,.1,.66,.2,1.34,.3,2.01,.03,.22,.07,.45,.1,.67,.33,2.24,.67,4.53,1.01,6.82,.05,.36,.11,.73,.16,1.1h0c.08,.55,.16,1.1,.24,1.65,.02,.15,.05,.3,.06,.45,.05,.33,.1,.66,.14,1,.21,1.45,.41,2.88,.61,4.3,.01,.07,.02,.15,.03,.22,.06,.43,.12,.85,.18,1.27,.01,.09,.03,.18,.04,.27,.1,.69,.19,1.37,.29,2.04,.11,.83,.23,1.64,.34,2.44,.13,.97,.26,1.91,.38,2.84,.03,.23,.06,.46,.09,.69,.32,2.43,.61,4.68,.85,6.65,.01,.11,.03,.22,.04,.32,.15,1.22,.27,2.33,.38,3.31,.01,.13,.03,.26,.04,.39h0c.01,.13,.03,.25,.04,.38,.09,.88,.15,1.62,.19,2.23,0,.07,0,.14,.01,.21v.12c.01,.07,.02,.14,.02,.21h0c0,.07,0,.14,0,.2,.02,.48,0,.79-.05,.89-.6,1.32-27.47-.12-42.45-1.03-1.71-.1-3.26-.2-4.6-.28h0c-1.4-.09-2.57-.17-3.44-.22-1.16-.08-1.81-.12-1.81-.12v2.57s.71,.03,1.96,.08c.15,0,.31,.01,.48,.02,.2,0,.41,.02,.63,.03,.36,.01,.75,.03,1.17,.05,.09,0,.18,0,.27,0,.17,0,.34,.01,.51,.02h.02c10.55,.43,35.07,1.37,48.46,1.44,5.01,.03,8.85,.25,9.03-.36,.2-.65-.49-9.19-1.75-20.15-.02-.16-.04-.33-.06-.49-.41-3.48-.86-7.2-1.37-10.98-.45-3.36-.93-6.77-1.45-10.1-.27-1.75-.54-3.47-.8-5.16-1.99-12.81-3.7-23.21-4.93-23.43-.67-.12-4.11-.62-8.21-.03h0c-.34,.05-.69,.11-1.04,.17-15.21,2.82-45.12,9.51-45.12,9.51Z",
    style: {
      fill: "#9b5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.53,63.38v2.26s.18-.04,.53-.13c.02,0,.04,0,.06-.02,.65-.15,1.8-.43,3.33-.79,1.07-.25,2.32-.55,3.7-.88,12.75-3.01,37.05-8.66,37.51-8.14,.02,.02,.05,.1,.08,.24,.01,.05,.03,.1,.04,.16,0,.02,0,.04,.01,.07,.02,.07,.03,.14,.05,.23,.02,.11,.05,.23,.07,.36l.02,.11s.01,.06,.02,.09c0,.04,.02,.09,.03,.13,.02,.12,.05,.24,.07,.36,0,.01,0,.03,0,.05,0,.03,0,.05,.01,.08,.02,.11,.04,.22,.06,.33,.02,.09,.03,.18,.05,.28,.02,.13,.05,.27,.07,.42,.02,.09,.03,.18,.05,.28,.02,.13,.05,.26,.07,.4,.02,.12,.04,.24,.06,.36,0,.06,.02,.12,.03,.18,.02,.11,.04,.21,.06,.32,.04,.24,.08,.5,.13,.76,.02,.11,.04,.21,.05,.32,.01,.07,.02,.14,.04,.21,.02,.14,.05,.29,.07,.43,.08,.51,.17,1.05,.26,1.61,.01,.09,.03,.19,.05,.29,.27,1.66,.57,3.51,.88,5.52,.08,.54,.17,1.09,.26,1.65,.12,.79,.25,1.6,.38,2.42,.05,.33,.1,.66,.15,1,.17,1.13,.35,2.29,.53,3.47,.07,.43,.13,.87,.2,1.31,.1,.66,.2,1.34,.3,2.01,.03,.22,.07,.45,.1,.67,.33,2.24,.67,4.53,1.01,6.82,.06,.36,.11,.73,.16,1.1,.08,.55,.16,1.1,.24,1.65,.02,.15,.05,.3,.06,.45,.05,.33,.1,.66,.14,1,.21,1.45,.41,2.88,.61,4.3,.01,.07,.02,.15,.03,.22,.06,.43,.12,.85,.18,1.27,.01,.09,.02,.18,.04,.27,.1,.69,.19,1.37,.29,2.04,.11,.83,.23,1.64,.34,2.44,.13,.97,.26,1.91,.38,2.84,.03,.23,.06,.46,.09,.69,.32,2.43,.61,4.68,.85,6.65,.01,.11,.03,.22,.04,.32,.15,1.22,.27,2.33,.38,3.31,.01,.13,.03,.26,.04,.39h0c.01,.13,.03,.25,.04,.38,.09,.88,.15,1.62,.19,2.23,0,.07,0,.14,.01,.21v.12c.01,.07,.02,.14,.02,.21h0c0,.07,0,.14,0,.2,.02,.48,0,.79-.05,.89-.6,1.32-27.47-.12-42.45-1.03-1.71-.1-3.26-.2-4.6-.28h0c-1.4-.09-2.57-.17-3.44-.22-1.16-.08-1.81-.12-1.81-.12v2.57s.71,.03,1.96,.08c.15,0,.31,.01,.48,.02,8.46,.35,36.87,1.46,51.55,1.54,.4-1.67-.56-10.24-1.98-21-.11-.8-.22-1.62-.33-2.44-.1-.76-.21-1.53-.31-2.31-.38-2.75-.77-5.59-1.18-8.46-.24-1.71-.48-3.42-.73-5.13-1.65-11.56-3.22-22.58-4.37-27.95-.19-.9-.37-1.64-.54-2.2-.22-.74-.42-1.15-.58-1.2h0c-.34,.05-.69,.11-1.04,.17-15.21,2.82-45.12,9.51-45.12,9.51Z",
    style: {
      fill: "url(#c)",
      mixBlendMode: "multiply",
      opacity: 0.47
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,79.15c.26,1.68,3.02,21.24,3.02,21.24l-53.27-.12s.21,1.71,.31,2.55l57.44,.12,.15,2.44h4.33l-.19-2.44h41.66c.11,.83,.23,1.64,.34,2.44h10.42c-.41-3.48-.86-7.2-1.37-10.98l-9.18-2.23-1.8-.44h0l-41.72-10.13-4.05-.98-6.09-1.48Z",
    style: {
      fill: "#4c2e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.14,4.07l2.94,17.29,3.67,21.6,3.35,19.74,.3,1.74,.04,.24,.3,1.78,3.53,20.79,.34,2.01,3.7-.49,.54-.07,.29-.04,28.38-3.75h0l1.73-.23,.87-.12,2.95-.39,2.85-.38,.72-.1,1.25-.16h.05l4.02-.54,1.53-.2,.64-.08,.78-.1,2.54-.34,1.74-.23,2.32-.31v-.1c.01-.14,.03-.44,.06-.89,0-.19,.02-.4,.04-.64,.01-.28,.03-.6,.05-.95,.12-2.4,.31-6.34,.47-11.2,.02-.55,.03-1.11,.05-1.68,.02-.61,.04-1.24,.05-1.88,0-.09,0-.18,0-.27,.02-.58,.03-1.17,.04-1.77,.01-.55,.02-1.11,.04-1.68,.07-3.52,.11-7.3,.1-11.17,0-1.37-.01-2.74-.03-4.12-.04-3.13-.12-6.28-.24-9.38-.14-3.43-.34-6.81-.62-10-2.02-23.27-2.67-21-4.16-22.18-1.49-1.18-16.55-1.37-16.55-1.37,0,0-1.34-.05-3.51-.15-2.16-.1-5.14-.23-8.43-.4-2-.1-4.11-.22-6.21-.34-5.41-.32-10.81-.7-14.27-1.1-.3-.04-.6-.07-.87-.11-.9-.12-1.81-.17-2.71-.17-.47,0-.93,.02-1.38,.04h0c-6.72,.41-12.64,3.52-13.21,3.82l-.05,.02Z",
    style: {
      fill: "#6397a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.41,87.41v12.87l50.47,.37h.38l36.67,.27,27.69,.2s2.2-10.37,0-16.48c-2.2-6.12-4.12-7.06-4.85-7.47-.16-.09-.96-.05-2.33,.05-1.72,.13-4.34,.39-7.64,.67-3.02,.26-6.62,.55-10.65,.79-4.55,.28-9.65,.5-15.1,.58-2.33,.03-4.48,.05-6.44,.05-6.47,0-11.01-.17-14.17-.34-1.59-.09-2.82-.18-3.78-.25-.3-.02-.56-.05-.81-.06-.77-.06-1.3-.1-1.64-.1h-.24c-1.36,.11-47.56,8.85-47.56,8.85Z",
    style: {
      fill: "#6397a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.14,4.07l12.75,96.27,48.89,.29s1.2-6.77,.81-12.34c-.23-3.26-.75-6.05-1.14-7.79-.27-1.23-.48-1.94-.48-1.94l-4.85,.76-4.48,.7-7.09,1.11-23.29,3.64s-.57-13.59-1.54-29.87c-.2-3.32-.41-6.74-.64-10.19-.06-.85-.11-1.69-.17-2.54h0c0-.07-.02-.3-.05-.67-.01-.17-.02-.33-.04-.5-.02-.31-.05-.63-.06-.94-.02-.3-.05-.63-.07-.98-.16-2.18-.32-4.35-.48-6.48-1.33-17.04-2.99-31.81-4.81-32.37-.3-.09-.62-.16-.96-.19-4.58-.48-12.31,4.04-12.31,4.04Z",
    style: {
      fill: "#425869"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.97,78.57s13.14,4.46,37.97,3.09c24.8-1.37,24.82-4.47,24.82-4.49l-2.32,.05c-5.07,.4-17.81,1.82-33.4,2.05-18.82,.26-25.11-.71-26.84-.71h-.24Z",
    style: {
      fill: "#ffe048",
      mixBlendMode: "screen",
      opacity: 0.48
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.44,0V.04c.34,.03,.67,.1,.96,.19,2.04,.64,3.9,19.25,5.29,38.85-.63-9.42-2.38-37.12-1.35-37.47,1.24-.42,15.32-.05,15.32-.05L73.44,0Z",
    style: {
      fill: "url(#d)",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.61,101.12s-7.92-2.47-31.94-2.76c-24.02-.29-34.89,2.28-34.89,2.28l66.83,.49Z",
    style: {
      fill: "#ad5d6e",
      mixBlendMode: "multiply",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.67 47.25 112.79 67.51 123.39 47.25 105.87 29.54 93.67 47.25",
    style: {
      fill: "#827c84",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.08,44.72c.23,3.45,.44,6.87,.64,10.19l24.83,26.22,7.09-1.11-32.56-35.31Z",
    style: {
      fill: "url(#e)",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.39,49.5l-16.27,29.82,4.85-.76s.48-.1,1.73,.08l9.59-17.97c.07-3.52,.11-7.3,.1-11.17Z",
    style: {
      fill: "url(#f)",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.21,32.6c.05,.63,.1,1.27,.15,1.91,.03,.44,.06,.87,.1,1.31,.06,.78,.12,1.56,.17,2.34,.02,.3,.04,.61,.06,.92,.02,.36,.05,.68,.07,.98,.02,.31,.04,.63,.06,.94,.01,.17,.02,.34,.04,.5,.02,.37,.04,.6,.05,.66h0c.06,.86,.12,1.71,.17,2.55L103.19,8.35l30.17,37.03c-.04-3.13-.12-6.28-.24-9.38L108.28,2.3c-2.16-.1-5.14-.23-8.43-.4l-20.57,30.61-.06,.09Z",
    style: {
      fill: "url(#g)",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,78.98l33.49,21.94,12.87-23.02c-3.02,.26-6.62,.55-10.65,.79l-6.03,10.79-15.51-10.16c-6.47,0-11.01-.17-14.17-.34Z",
    style: {
      fill: "#827c84",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.92,9.15l.03,.24,2.12,14.97,5.89,41.59,.25,1.79,.03,.22h0l.25,1.76,3.91,27.57,.64,4.54,.06-.13,.36-.72,4.66-9.32,1.21-2.42v-.1s0-.03,0-.04c0-.07-.01-.15-.02-.23-.23-2.78-.91-10.91-1.79-21.05-.06-.65-.11-1.31-.17-1.98h0c0-.12-.02-.24-.03-.37-.04-.5-.09-1.01-.13-1.52-2.09-24.02-5.07-56.25-6.04-57.82-1.58-2.54-9.46,1.97-11.03,2.9l-.21,.12Zm.78,.37c3.41-2,8.93-3.99,9.84-3.02,1.08,1.15,3.65,29.76,5.99,57.58,.05,.52,.09,1.03,.13,1.54,.01,.12,.02,.24,.03,.36,.06,.66,.11,1.32,.17,1.97,.62,7.37,1.21,14.59,1.75,21.14l-.07,.15-1.23,2.51-4.07,8.35-.84-6.05-3.39-24.46-.25-1.77-.03-.23-.24-1.78-2.75-19.87-5.04-36.43Z",
    style: {
      fill: "url(#h)",
      mixBlendMode: "multiply",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.67,89.12c-.08,7.57-1.12,11.4-1.13,11.44l.34,.09,.36,.1s.01-.04,.02-.1c.17-.65,1.06-4.42,1.13-11.52,.07-6.57-1.28-9.57-1.73-10.4-.3-.02-.56-.05-.81-.06,.6,1.28,1.88,4.7,1.82,10.46Z",
    style: {
      fill: "url(#i)",
      mixBlendMode: "multiply",
      opacity: 0.48
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,101.24c.02-.06,2.14-6.39,1.32-13.1-.82-6.74-5.02-11-5.2-11.18l-.51,.51s4.2,4.26,5,10.75c.8,6.53-1.27,12.72-1.29,12.78l.68,.23Z",
    style: {
      fill: "url(#j)",
      mixBlendMode: "multiply",
      opacity: 0.48
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.05 98.7 118.65 98.7 117.45 81.08 81.3 85.87 81.39 86.58 116.79 81.9 117.88 97.98 75.05 97.98 75.05 98.7",
    style: {
      fill: "url(#k)",
      mixBlendMode: "multiply",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.44,63.29c-.08,.33-42.74,9.22-42.74,9.22h-7.23s42.29-11.18,48.01-10.69c5.72,.49,1.96,1.47,1.96,1.47Z",
    style: {
      fill: "#4c2e2e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.92 70.72 61.95 71.21 62.39 78.2 65.6 128.82 70.19 128.82 66.29 78.56 65.67 70.61 65.6 69.64 61.92 70.72",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.8 70.72 62.83 71.21 63.28 78.2 66.48 128.82 71.07 128.82 67.17 78.56 66.55 70.61 66.48 69.64 62.8 70.72",
    style: {
      fill: "#9b5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.83,71.21l.44,6.99c1.42-.09,2.73,.07,3.89,.37l-.62-7.96-3.72,.6Z",
    style: {
      fill: "#4c2e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.94,70.38v2.26s.18-.04,.53-.13c.02,0,.04,0,.06-.02,.65-.15,1.8-.43,3.33-.79,1.07-.25,2.32-.55,3.7-.88,12.75-3.01,37.05-8.66,37.51-8.14,.02,.02,.05,.1,.08,.24,.01,.05,.03,.1,.04,.16,0,.02,0,.04,.01,.07,.01,.07,.03,.14,.05,.23,.02,.11,.05,.23,.07,.36,0,.03,.01,.07,.02,.11,0,.03,.01,.06,.02,.09,0,.04,.02,.09,.03,.13,.02,.12,.05,.24,.07,.36v.05s.02,.05,.02,.08c.02,.11,.04,.22,.06,.33,.02,.09,.03,.18,.05,.28,.02,.13,.05,.27,.07,.42,.02,.09,.03,.18,.05,.28,.02,.13,.05,.26,.07,.4,.02,.12,.04,.24,.06,.36,0,.06,.02,.12,.03,.18,.02,.11,.04,.21,.06,.32,.04,.24,.08,.5,.13,.76,.02,.11,.04,.21,.05,.32,.01,.07,.02,.14,.04,.21,.02,.14,.05,.29,.07,.43,.08,.51,.17,1.05,.26,1.61,.01,.09,.03,.19,.05,.29,.27,1.66,.57,3.51,.88,5.52,.08,.54,.17,1.09,.26,1.65,.12,.79,.25,1.6,.38,2.42,.05,.33,.1,.66,.15,1,.17,1.13,.35,2.29,.53,3.47,.07,.43,.13,.87,.2,1.31,.1,.66,.2,1.34,.3,2.01,.03,.22,.07,.45,.1,.67,.33,2.24,.67,4.53,1.01,6.82,.13,.91,.27,1.83,.4,2.74,.02,.15,.05,.3,.06,.45,.05,.33,.1,.66,.14,1,.21,1.45,.41,2.88,.61,4.3,.01,.07,.02,.15,.03,.22,.05,.33,.09,.66,.14,.99,.03,.18,.06,.37,.08,.56,.1,.69,.19,1.37,.29,2.04,.25,1.83,.49,3.59,.72,5.28,.03,.23,.06,.46,.09,.69,.32,2.43,.61,4.68,.85,6.65,.01,.11,.03,.22,.04,.32,.15,1.22,.27,2.33,.38,3.31,.01,.13,.03,.26,.04,.39h0c.01,.13,.03,.25,.04,.38,.09,.88,.15,1.62,.19,2.23,0,.07,0,.14,.01,.21v.12c.01,.07,.02,.14,.02,.21h0c0,.07,0,.14,0,.2,.02,.48,0,.79-.05,.89-.6,1.32-27.47-.12-42.45-1.03-1.71-.1-3.26-.2-4.6-.28h0c-3.24-.21-5.25-.34-5.25-.34v2.57s.88,.04,2.44,.1c8.4,.35,36.4,1.46,51.06,1.54,5.01,.03,8.85,.25,9.03-.36,.04-.12,.04-.54,.02-1.21-.02-.63-.08-1.49-.15-2.53-.26-3.62-.83-9.54-1.62-16.41-.02-.16-.04-.33-.06-.49-.09-.8-.19-1.62-.29-2.44-.1-.84-.2-1.69-.31-2.55-.65-5.22-1.39-10.75-2.22-16.08-.27-1.75-.54-3.47-.8-5.16-1.99-12.81-3.7-23.21-4.93-23.43-.67-.12-4.11-.62-8.21-.03h0c-.34,.05-.69,.11-1.04,.17-15.21,2.82-45.12,9.51-45.12,9.51Z",
    style: {
      fill: "#9b5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.08,62.68c.63,.71,10.21,64.3,9.37,66.14s-52.31-1.65-52.31-1.65v2.57s36.61,1.55,53.98,1.64c.61-2.56-1.96-21.33-4.53-39.34-2.3-16.07-4.44-31.09-5.48-31.35h0c-.34,.05-.69,.11-1.04,.17-15.21,2.82-45.12,9.51-45.12,9.51v2.26s44.51-10.66,45.14-9.95Z",
    style: {
      fill: "url(#m)",
      mixBlendMode: "multiply",
      opacity: 0.47
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.32,85.17l.05,.37,.11,.75,1.96,14.06,.36,2.59,.31,2.24v.06l.03,.14h8.73c-.09-.8-.19-1.62-.29-2.44-.1-.84-.2-1.69-.31-2.55-.65-5.22-1.39-10.75-2.22-16.08-.27-1.75-.54-3.47-.8-5.16l-7.92,6.02Z",
    style: {
      fill: "#4c2e2e"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "34.22 125 18.63 129.87 17 130.38 5.14 95.87 7 95.08 14.33 93.7 13.86 92.31 34.22 125",
    style: {
      fill: "#af4350",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.22 125 18.63 129.87 7 95.08 14.33 93.7 13.86 92.31 34.22 125",
    style: {
      fill: "#dd6876",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "33.42 112.59 17.34 115.5 15.67 115.81 8.14 80.1 10.08 79.55 35.76 81.61 36.15 81.51 36.19 81.6 33.42 112.59",
    style: {
      fill: "url(#n)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.78 119.35 17.34 115.5 10.08 79.55 35.76 81.61 36.19 81.6 40.78 119.35",
    style: {
      fill: "#80c493",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "42.89 117.16 26.81 120.08 22.57 121.88 15.04 86.17 19.55 84.12 45.23 86.19 45.62 86.08 45.66 86.17 42.89 117.16",
    style: {
      fill: "#6b4369",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.25 123.92 26.81 120.08 19.55 84.12 45.23 86.19 45.66 86.17 50.25 123.92",
    style: {
      fill: "#936f93",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.53,126.75l-2.22-.36-3.43-29,3.11,.24c.45,5.08,1.73,19.53,2.55,29.12Z",
    style: {
      fill: "#90404a",
      fillRule: "evenodd",
      mixBlendMode: "multiply",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.33 118.52 13.38 87.25 15.04 86.17 23.36 119.81 18.33 118.52",
    style: {
      fill: "#90404a",
      fillRule: "evenodd",
      mixBlendMode: "multiply",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.53,96.16l-1.96,39.62H30.25c.08-.41-3.43-39.99-3.43-39.99l9.09-3.47,.14,.02,25.49,3.82Z",
    style: {
      fill: "#ffbdc5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25,135.78c.02-.12-.28-3.87-.72-9.03-.82-9.59-2.09-24.04-2.55-29.12-.1-1.17-.16-1.85-.16-1.85l9.09-3.47,.14,.02,1.51,43.44h-7.31Z",
    style: {
      fill: "#cb5962",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.87 106.03 80.16 115.17 80.05 116.6 80.05 116.62 80.04 116.69 79.51 123.55 79.5 123.68 78.8 136.45 4.47 136.45 1.37 114.49 0 106.5 31.69 104.05 32.04 104.02 80.87 106.03",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.19 114.46 79.9 117.68 79.81 118.72 79.11 136.45 34.08 137.45 4.47 136.45 3.35 127.6 3.22 126.59 .82 112.31 32.02 112.01 32.62 112.04 37.92 112.31 38.01 112.31 39 112.36 40.61 112.44 51.96 113.02 52.95 113.07 54.19 113.14 55.17 113.19 55.4 113.2 55.83 113.22 56.46 113.25 56.85 113.27 57.01 113.28 57.25 113.29 57.54 113.31 58.35 113.35 58.53 113.36 65.1 113.69 65.63 113.72 66.67 113.77 67.61 113.82 68.91 113.89 78.58 114.38 79.23 114.41 79.75 114.44 80.04 114.45 80.19 114.46",
    style: {
      fill: "#ff896a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.26,124.81c0,.31-.25,.56-.56,.56s-.56-.25-.56-.56,.25-.56,.56-.56,.56,.25,.56,.56Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.15,133.58c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.98,124.17c0,.31-.25,.56-.56,.56s-.56-.25-.56-.56,.25-.56,.56-.56,.56,.25,.56,.56Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.03,115.36c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.64,124.94c0,.24-.19,.43-.43,.43s-.43-.19-.43-.43,.19-.43,.43-.43,.43,.19,.43,.43Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.53,133.84c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.41,115.63c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72,134.1c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 124.75,
    r: 0.61,
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8,115.81c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8,134.69c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,133.92c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,115.63c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61,115.89c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12,.5-1.12,1.12-1.12,1.12,.5,1.12,1.12Z",
    style: {
      fill: "#f7dfd8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "34.23 137.45 4.47 136.45 1.37 114.49 0 106.5 31.69 104.05 32.38 111.81 32.51 113.26 32.62 114.49 32.62 114.52 34.23 137.45",
    style: {
      fill: "#90404a",
      opacity: 0.5
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.805c58932487b76e57fb1921cc01d51f.svg";
export { ForwardRef as ReactComponent };